import * as React from "react";
const SvgSizeCFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 18a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h3V7.667a2 2 0 0 1 2-2l3-.001V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zM20 4h-6v1.666h1a2 2 0 0 1 2 2V16h3zm.5 16a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2z", clipRule: "evenodd" }));
export default SvgSizeCFill;
